import isEqual from 'fast-deep-equal';
import { useSelector } from 'app/store';
import {
  linksLinkSignalLabelParamsSelector,
  linksLinkMcsSelector,
  linksLinkPhyRatesMapSelector,
  linksLinkSpeedSelector,
  linksUplinkIdByClientIdSelector,
  linksLinkVariantSelector,
  linksLinkSignalLabelSelector,
} from 'modules/links/slice';

import { LinkTooltip as LinkTooltipView } from '../components/LinkTooltip';
import { LinkTooltipContent } from '../components/LinkTooltipContent';
import { useEditorStore } from '../store';

export const LinkTooltip = () => {
  const hoverDeviceId = useEditorStore((state) => state.hoverDeviceId);
  const uplinkId = useSelector((state) => hoverDeviceId && linksUplinkIdByClientIdSelector(state, hoverDeviceId));
  const variant = useSelector((state) => (uplinkId ? linksLinkVariantSelector(state, uplinkId) : undefined));
  const signalLabel = useSelector((state) => (uplinkId ? linksLinkSignalLabelSelector(state, uplinkId) : undefined));
  const signalLabelParams = useSelector((state) =>
    uplinkId ? linksLinkSignalLabelParamsSelector(state, uplinkId) : undefined
  );
  const mcs = useSelector((state) => (uplinkId ? linksLinkMcsSelector(state, uplinkId) : undefined));
  const speed = useSelector((state) => (uplinkId ? linksLinkSpeedSelector(state, uplinkId, variant) : undefined));
  const phyRatesMap = useSelector(
    (state) => (uplinkId ? linksLinkPhyRatesMapSelector(state, uplinkId) : undefined),
    isEqual
  );

  return (
    <LinkTooltipView
      description={
        <LinkTooltipContent
          mcs={mcs}
          phyRatesMap={phyRatesMap}
          signalLabel={signalLabel}
          signalLabelParams={signalLabelParams}
          speed={speed}
        />
      }
    />
  );
};
